/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('data.client-manager', []);
